import { render, staticRenderFns } from "./roadmap_status_label.vue?vue&type=template&id=43c01890&scoped=true&"
import script from "./roadmap_status_label.vue?vue&type=script&lang=js&"
export * from "./roadmap_status_label.vue?vue&type=script&lang=js&"
import style0 from "./roadmap_status_label.vue?vue&type=style&index=0&id=43c01890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c01890",
  null
  
)

export default component.exports